module.exports = __webpack_public_path__ + "static/media/TOGF_500.888808e2.png";